import { getStage } from "../../content/stages.js";
import { createRun } from "../run/createRun.js";
import type { Command, GameState } from "../types/index.js";
import { accept } from "./reject.js";
import { resetLogCounter } from "../run/log.js";

export function handleStartNew(state: GameState, command: Extract<Command, { type: "START_NEW" }>): GameState {
  resetLogCounter();
  // テストやリプレイでseedを指定した場合だけ、その並びを再現する。
  // 通常の新規ランは開始時刻をseedにして毎回デッキと負荷の順番を変える。
  const seed = command.seed ?? Date.now();
  // 持ち込みは許可されたステージでのみ有効。それ以外に指定されても無視する。
  const bringInCardId = getStage(command.stageId).allowBringIn ? command.bringInCardId : undefined;
  const run = createRun({ seed, stageId: command.stageId, runId: command.runId, bringInCardId });
  return accept({
    ...state,
    screen: "map",
    bringInStageId: null,
    run,
    resolution: null,
    activeEvent: null,
    overlay: "none",
  });
}
